<template>
  <div class="ma3-l list-grid">
    <div class="list-item">
      <checkbox label="показать все события" id="showAllEvents" value="showAllEvents" :checked="showAll" @change="toggleShowAll"/>
    </div>
    <journal-item v-for="(item, index) in filteredJournal" :key="index" :item="item" class="list-item" />
  </div>
</template>

<script>
import JournalItem from './JournalItem.vue'
import Checkbox from '@/components/ui/Checkbox.vue'

export default {
  props: ['journal'],
  components: {
    JournalItem,
    Checkbox
  },
  data: () => ({
    showAll: false
  }),
  computed: {
    filteredJournal () {
      return this.showAll
        ? this.journal
        : this.journal.filter(i => (i.eventType !== 8))
    }
  },
  methods: {
    toggleShowAll (v) {
      this.showAll = v.checked
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
